import { Module, ModuleMap, Trigger } from "types/type.module.js";
import { extractLogicalOperation } from "./Steps";

/**
  @function labelTrigger
  create label for triggers
  @param trigger {obj} - to translate
  @param module {obj} - to read information
  @param moduleMap {obj} - to navigate
*/
export function labelTrigger({
  trigger,
  module,
  moduleMap,
}: {
  trigger: Trigger;
  module: Module;
  moduleMap: ModuleMap;
}): any {
  const operation = extractLogicalOperation(trigger);

  if (operation.operation === "and") {
    return {
      and: operation.elements?.map((el: any) => {
        if (typeof el !== "string" && "answer" in el && el.answer) {
          const answerPos = moduleMap.triggers[el.answer];
          try {
            const chapter_order_number =
              module.chapters[answerPos.chapterPos].order_number;
            const question_order_number =
              module.chapters[answerPos.chapterPos].questions[
                answerPos.questionPos
              ].order_number;
            const answer_order_number =
              module.chapters[answerPos.chapterPos].questions[
                answerPos.questionPos
              ].possible_answers[answerPos.triggerPos].order_number;

            return {
              ...el,
              label: `A.${chapter_order_number}.${question_order_number}.${answer_order_number}`,
            };
          } catch (e) {
            return {
              ...el,
              label: "not present",
            };
          }
        } else if (typeof el !== "string" && "question" in el && el.question) {
          const answerPos = moduleMap.questions[el.question];
          try {
            const chapter_order_number =
              module.chapters[answerPos.chapterPos].order_number;
            const question_order_number =
              module.chapters[answerPos.chapterPos].questions[
                answerPos.questionPos
              ].order_number;

            return {
              ...el,
              label: `Q.${chapter_order_number}.${question_order_number}`,
            };
          } catch (e) {
            return {
              ...el,
              label: "not present",
            };
          }
        } else if (Object.keys(el).length === 0) {
          return {};
        } else {
          return labelTrigger({
            trigger: el as Trigger,
            module: module,
            moduleMap: moduleMap,
          });
        }
      }),
    };
  }
  if (operation.operation === "or") {
    return {
      or: operation.elements?.map((el: any) => {
        if (el === "always") {
          return el;
        }
        if (typeof el !== "string" && "answer" in el && el.answer) {
          const answerPos = moduleMap.triggers[el.answer];

          const chapter_order_number =
            module.chapters[answerPos.chapterPos].order_number;
          const question_order_number =
            module.chapters[answerPos.chapterPos].questions[
              answerPos.questionPos
            ].order_number;
          const answer_order_number =
            module.chapters[answerPos.chapterPos].questions[
              answerPos.questionPos
            ].possible_answers[answerPos.triggerPos].order_number;

          return {
            ...el,
            label: `A.${chapter_order_number}.${question_order_number}.${answer_order_number}`,
          };
        } else if (typeof el !== "string" && "question" in el && el.question) {
          const answerPos = moduleMap.questions[el.question];

          const chapter_order_number =
            module.chapters[answerPos.chapterPos].order_number;
          const question_order_number =
            module.chapters[answerPos.chapterPos].questions[
              answerPos.questionPos
            ].order_number;

          return {
            ...el,
            label: `Q.${chapter_order_number}.${question_order_number}`,
          };
        } else if (Object.keys(el).length === 0) {
          return {};
        } else {
          return labelTrigger({
            trigger: el as Trigger,
            module: module,
            moduleMap: moduleMap,
          });
        }
      }),
    };
  }
}

/**
  @function conditionTranslator
  translate condition to have each trigger to be enclosed by one or and and operator
  @param trigger {obj} - to translate
  @param depth {number} - to depth of trigger
*/
export function ConditionTranslator({
  trigger,
  depth,
}: {
  trigger: Trigger;
  depth: number;
}): any {
  const operation = extractLogicalOperation(trigger);

  if (operation.operation === "or") {
    return {
      or: operation.elements?.map((el: any) => {
        if (el === "always") {
          return el;
        }
        if ("chapter" in el) {
          if (depth < 1) {
            return (el = { and: [el] });
          }
          return el;
        } else {
          if ("and" in el || "or" in el) {
            return ConditionTranslator({ trigger: el, depth: depth + 1 });
          } else {
            return el;
          }
        }
      }),
    };
  }
  if (operation.operation === "and") {
    return {
      and: operation.elements?.map((el: any) => {
        if (typeof el !== "string" && "chapter" in el) {
          if (depth < 2) {
            return { or: [{ and: [el] }] };
          } else {
            return el;
          }
        } else {
          if (typeof el !== "string" && ("and" in el || "or" in el)) {
            return ConditionTranslator({ trigger: el, depth: depth + 1 });
          } else {
            return el;
          }
        }
      }),
    };
  }
}
